import { Controller } from '@hotwired/stimulus'
import { hideElement, showElement } from 'utils/toggle_element_visibility'

export default class extends Controller {
  static targets = ["addButton", "submitButton", "continueButton", "body", "row", "rowEditable", "emptyRow", "form", "successAlert", "input", "dropdown", "removeEmptyButton"]

  initialize() {
    // This is auto generated by cocoon https://github.com/nathanvda/cocoon
    this.insertionTemplate = this.addButtonTarget.getAttribute("data-association-insertion-template")

    this.newRowCount = 0
    this.notRequiredList = JSON.parse(this.formTarget.dataset.notRequiredList)

    this._disableActions()
    this._updateInsertionTemplate(null)

    this._disableAddJurisdictionScrollTop()
  }

  submitJurisdictions(event) {
    this._enableContinueButton(event)

    // Wait a bit until DOM is updated after removal
    setTimeout(() => {
      this._disableActions()
      this._toggleActions() // Re-enable Add button after removing editable fields
    }, 500)
  }

  removeJurisdiction(_event) {
    // Disable continue button if there are no more rows
    // Length <= 1 used since DOM isn't updated yet so the last known available row target is 1
    // Continue button handle instantly rather than having a second delay before action
    if (this.hasContinueButtonTarget && this.rowTargets.length <= 1) {
      this.continueButtonTarget.setAttribute("disabled", true)
    }

    // Display empty panel when no more rows
    // Length <= 1 used since DOM isn't updated yet so the last known available row target is 1
    // Disable submit button since nothing to submit with empty row
    if ((this.rowTargets.length + this.rowEditableTargets.length) <= 1) {
      showElement(this.emptyRowTarget)
      this.submitButtonTarget.setAttribute("disabled", true)
    }
  }

  removeEmptyJurisdiction(event) {
    // Params unable to be retrieved and keep returning undefined so need to manually retrieve licenseId
    const licenseId = event.currentTarget.getAttribute("data-item-license-id-param")
    let newRow = null

    if (licenseId === "" || licenseId === null) {
      newRow = document.querySelector("[data-manage-jurisdiction-row='']")
    } else {
      newRow = document.querySelector(`[data-manage-jurisdiction-row='new-row-${licenseId}']`)
    }

    if (newRow !== null) {
      newRow.remove()
    }

    // Display empty panel when no more rows
    if (this.rowTargets.length === 0 && this.rowEditableTargets.length === 0) {
      showElement(this.emptyRowTarget)
    }

    // Wait a bit until DOM is updated after removal
    setTimeout(this._disableActions(), 500)
    this._toggleActions() // Re-enable Add button after removing editable fields
  }

  handleAddRowButton(event) {
    // Disallow add row button to fire cocoon events when disabled
    if (event.target.getAttribute("disabled") === "true") {
      event.stopPropagation()
    }

    hideElement(this.emptyRowTarget)
  }

  addJurisdiction(_event) {
    this._updateInsertionTemplate(this.newRowCount - 1)
    this._disableActions()
  }

  editJurisdiction(_event) {
    if (this.hasContinueButtonTarget) {
      this.continueButtonTarget.setAttribute("disabled", true)
    }

    // Reable submit button if no other submittable rows to complete
    if (this.rowEditableTargets.length === 0) {
      this.submitButtonTarget.removeAttribute("disabled")
    }
  }

  detectInputChange(_event) {
    this._toggleActions()
  }

  _disableActions() {
    if (this.rowEditableTargets.length > 0) {
      this.addButtonTarget.setAttribute("disabled", true)
    }

    if (this.hasContinueButtonTarget && this.rowTargets.length === 0) {
      this.continueButtonTarget.setAttribute("disabled", true)
    }

    this.submitButtonTarget.setAttribute("disabled", true)
  }

  _enableActions() {
    this.addButtonTarget.removeAttribute("disabled")

    if (this.dropdownTargets.length > 0 && this.inputTargets.length > 0) {
      this.submitButtonTarget.removeAttribute("disabled")
    }
  }

  _enableContinueButton(_event) {
    if (this.hasContinueButtonTarget) {
      this.continueButtonTarget.removeAttribute("disabled")
    }
  }

  _updateInsertionTemplate(id) {
    let insertionTemplate = this.insertionTemplate

    if (id === null) {
      insertionTemplate = insertionTemplate.replaceAll(`data-manage-jurisdiction-row=""`, `data-manage-jurisdiction-row="new-row-${this.newRowCount}"`)
      insertionTemplate = insertionTemplate.replaceAll(`data-item-license-id-param=""`, `data-item-license-id-param="${this.newRowCount}"`)
    } else {
      insertionTemplate = insertionTemplate.replaceAll(`data-manage-jurisdiction-row="new-row-${id}"`, `data-manage-jurisdiction-row="new-row-${this.newRowCount}"`)
      insertionTemplate = insertionTemplate.replaceAll(`data-item-license-id-param="${id}"`, `data-item-license-id-param="${this.newRowCount}"`)
    }

    this.insertionTemplate = insertionTemplate
    this.addButtonTarget.setAttribute("data-association-insertion-template", this.insertionTemplate)

    this.newRowCount += 1
  }

  _toggleActions() {
    // Enable Add and Submit button if all fields filled out
    this._enableActions()
    this._toggleAction(this.inputTargets)
    this._toggleAction(this.dropdownTargets)
  }

  _toggleAction(inputs) {
    inputs.forEach((input) => {
      if (input.dataset.required === "true" || this._isRequired(this._jurisdictionFor(input))) {
        input.removeAttribute("disabled")
        if (input.value === "" || input.value === null) {
          this._disableActions()
        }
      } else {
        input.value = null
        input.setAttribute("disabled", "disabled")
      }
    })
  }

  // Disables cocoon href="#" default scroll to top when disable for Add jurisdiction button
  // https://stackoverflow.com/a/21717034
  _disableAddJurisdictionScrollTop() {
    this.addButtonTarget.setAttribute("href", "#/")
  }

  _isRequired(id) {
    // Is not in the not-required list
    return this.notRequiredList.indexOf(id) === -1
  }

  _jurisdictionFor(input) {
    return parseInt(input.closest("[data-manage-jurisdiction-row]").querySelector("select[data-jurisdiction-field]").value)
  }
}
